export default __webpack_public_path__ + "static/media/award.a022ffb1.jpeg";